var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_190_6654)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3332 8.02236C13.3066 6.70379 15.6266 6 18 6C21.1826 6 24.2348 7.26428 26.4853 9.51472C28.7357 11.7652 30 14.8174 30 18C30 20.3734 29.2962 22.6935 27.9776 24.6668C26.6591 26.6402 24.7849 28.1783 22.5922 29.0866C20.3995 29.9948 17.9867 30.2324 15.6589 29.7694C13.3312 29.3064 11.193 28.1635 9.51472 26.4853C7.83649 24.8071 6.6936 22.6689 6.23058 20.3411C5.76756 18.0133 6.0052 15.6005 6.91345 13.4078C7.8217 11.2151 9.35977 9.34094 11.3332 8.02236ZM17.2292 12.5379C17.0228 12.7515 16.9068 13.0413 16.9068 13.3434V18.8472C16.9068 18.9968 16.9353 19.1449 16.9906 19.2831C17.0459 19.4213 17.127 19.5469 17.2292 19.6527C17.3313 19.7585 17.4527 19.8424 17.5862 19.8996C17.7197 19.9569 17.8628 19.9863 18.0073 19.9863C18.1518 19.9863 18.2949 19.9569 18.4284 19.8996C18.562 19.8424 18.6833 19.7585 18.7855 19.6527C18.8877 19.5469 18.9687 19.4213 19.024 19.2831C19.0793 19.1449 19.1078 18.9968 19.1078 18.8472V13.3434C19.1078 13.0413 18.9918 12.7515 18.7855 12.5379C18.5791 12.3243 18.2992 12.2042 18.0073 12.2042C17.7154 12.2042 17.4355 12.3243 17.2292 12.5379ZM18 23.7958C18.6969 23.7958 19.2619 23.2433 19.2619 22.5617C19.2619 21.8801 18.6969 21.3276 18 21.3276C17.3031 21.3276 16.7381 21.8801 16.7381 22.5617C16.7381 23.2433 17.3031 23.7958 18 23.7958Z",
    fill: "#F2C218"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_190_6654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.296c95cea7a89dd4e59558486240f3f5.svg";
export { ForwardRef as ReactComponent };